import InstallApplication from "./InstallApplication";
export default InstallApplication